module.exports = __webpack_public_path__ + "img/Enhanced-Privacy-Options.8d104ed9.webp";